"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidNotes = hasValidNotes;
exports.default = isValidBrief;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function hasValidNotes(notesToTheEditor) {
  if (!notesToTheEditor) {
    return false;
  }

  try {
    var notes = JSON.parse(notesToTheEditor);
    return Boolean((0, _lodash.default)(notes, 'blocks[0].text'));
  } catch (_unused) {
    return false;
  }
}

function isValidBrief(video) {
  if (!video) {
    return false;
  }

  var clips = video.clips,
      notesToTheEditor = video.notesToTheEditor;
  return clips && clips.length && hasValidNotes(notesToTheEditor);
}